import React,{useState} from 'react';
import {connect} from 'react-redux';
import {delAccounts} from '../store/teachActions';

const TeachDelAccounts = ({delAccounts}) => {
  const [input, setInput] = useState({
    course: '',
    confirm: ''
  });
  const {course,confirm}=input;

  const onChange = e => setInput({...input, [e.target.name]: e.target.value});
  const onSubmit = (e) => {
    e.preventDefault();
    delAccounts(course);
    setInput({course: '',confirm: ''});
  };

  return (
    <div className='form-container' style={{'margin':'50px 50px 50px 50px'}}>
      <form onSubmit={onSubmit}>
        <div className='row container'>
          <div>
            <label htmlFor='course'>Course</label>
            <input type='text' name='course' value={course} onChange={onChange} required />
          </div>
          <div>
            <label htmlFor='confirm'>Type YES to confirm</label>
            <input type='text' name='confirm' value={confirm} onChange={onChange} required />
          </div>
          <input disabled={confirm!=='YES'} type='submit' value='Delete course accounts' className='btn btn-primary btn-block' />
        </div>
      </form>
    </div>

  );
};

export default connect(null,{delAccounts})(TeachDelAccounts);
